module.exports = __webpack_public_path__ + "static/media/world.ab6bd653.geojson";